import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnReconnect: "always",
      refetchOnWindowFocus: "always",
      refetchOnMount: "always",
      // staleTime: 1000,
    },
  },
});
